export const CREATE_OPTIONS = {
  facebook: 0,
  default: 1,
};
